/* istanbul ignore file */
import React, { useContext } from 'react';

export interface SidebarContextData {
  mobileOpen?: boolean;
  handleDrawerToggle?: () => void;
  collapsed: boolean;
  setCollapsed: (v: boolean) => void;
  isDesktop: boolean;
}

const SidebarContext = React.createContext<Partial<SidebarContextData>>({
  collapsed: false,
  setCollapsed: (v: boolean) => {},
});

export const SidebarProvider = SidebarContext.Provider;

export const useSidebarContext = () => useContext(SidebarContext);
